<template>
    <b-overlay
        :show="showOverlay"
        rounded="sm"
        spinner-variant="primary"
        spinner-small
    >
        <b-row class="pb-2">
            <b-col>
                <h4 v-if="null === id">
                    {{ $t('Page(SubscriberCard):Component(Text):add') }}
                </h4>
                <h4 v-else>
                    {{ $t('Page(SubscriberCard):Component(Text):edit', {subscriber: subscriber.title}) }}
                </h4>
            </b-col>
            <b-col md="6" lg="6">
                <Actions
                    class="float-right"
                    @save="save"
                    @close="close"
                />
            </b-col>
        </b-row>

        <b-row>
            <b-col md="6" lg="6">
                <GeneralInfo
                    ref="generalInfo"
                    @input="onGeneralInfoChange"
                />
            </b-col>
            <b-col md="6" lg="6">
                <Subscriptions
                    ref="subscription"
                    @update="onSubscriptionUpdate"
                    @create="onSubscriptionCreate"
                    :subscriptions="subscriptions"
                />
            </b-col>
        </b-row>
        <b-row>
            <b-col md="6" lg="6">
                <LegalIdentities
                    :identities="legalIdentities"
                    @add="addLegalIdentity"
                    @remove="removeLegalIdentity"
                    @change="legalIdentityChange"
                />
            </b-col>
            <b-col md="6" lg="6">
                <Domains
                    :domains="domains"
                    @add="addDomain"
                    @remove="removeDomain"
                    @change="updateDomain"
                />
            </b-col>
        </b-row>
    </b-overlay>
</template>

<script>
import {required} from '@validations'
import {OrganizationType} from "@/libs/supply-chain";
import {BRow, BCol, BOverlay, BCard, BCardTitle, BFormGroup, BFormInput} from 'bootstrap-vue'
import Actions from "@/views/administration/subscriber/components/Actions";
import GeneralInfo from "@/views/administration/subscriber/components/GeneralInfo";
import {SubscriberApi} from "@core/api";
import backendResponse from "@core/mixins/ui/backend-response";
import LegalIdentities from "@/views/administration/subscriber/components/LegalIdentities.vue";
import RepeatableElementCard from "@core/components/common/RepeatableElementCard.vue";
import LegalIdentitiesSupport from "@/views/administration/subscriber/mixin/LegalIdentitiesSupport.vue";
import DomainsSupport from "@/views/administration/subscriber/mixin/DomainsSupport.vue";
import Domains from "@/views/administration/subscriber/components/Domains.vue";
import Subscriptions from "@/views/administration/subscriber/components/Subscriptions.vue";
import SubscriptionsSupport from "@/views/administration/subscriber/mixin/SubscriptionsSupport.vue";

export default {
    mixins: [backendResponse, LegalIdentitiesSupport, DomainsSupport, SubscriptionsSupport],
    components: {
        Subscriptions,
        Domains,
        RepeatableElementCard,
        LegalIdentities,
        BRow, BCol, BOverlay, BCard, BCardTitle, Actions, GeneralInfo, BFormGroup, BFormInput
    },
    props: {
        id: {
            default: null
        }
    },
    data() {
        return {
            title: null,
            description: null,
            comment: null,

            subscription: {},
            subscriber: {},

            showOverlay: false,
            organizationType: OrganizationType.INTERNAL,
            validateReadyStateCounter: 1,
            validateReadyStateLimit: 30,
            required,
        };
    },
    methods: {
        save() {
            Promise.all([
                this.$refs.generalInfo.validate(),
                this.$refs.subscription.validate()
            ]).then((events) => {
                if (events.includes(false)) {
                    return;
                }
                this.showOverlay = true;
                const subscriber = {
                    ...this.subscriber,
                    legalIdentities: this.legalIdentities.map(le => {
                        return {
                            type: le.type ? le.type.id : null,
                            value: le.value
                        }
                    }),
                    domains: this.domains
                };
                SubscriberApi.create(subscriber, this.subscriptions).then((r) => {
                    this.showDefaultSuccessMessage('Request has been sent, please wait for a while...', false);
                    this.validateReadyState(r.data.id);
                }).catch((e) => {
                    this.handleBackendError(e);
                    this.showOverlay = false;
                });
            });
        },
        close() {
            this.$router.go(-1);
        },
        onGeneralInfoChange(generalInfo) {
            this.subscriber = generalInfo;
        },
        validateReadyState(id) {
            if (this.validateReadyStateCounter > this.validateReadyStateLimit) {
                // todo notify user
                return;
            }

            setTimeout(() => {
                this.validateReadyStateCounter++;
                SubscriberApi.get(id).then(r => {
                    if (r.data.isManageable) {
                        this.edit(id);
                    } else {
                        this.validateReadyState(id);
                    }
                }).catch(this.handleBackendError);
            }, 2000);
        },
        edit(id) {
            this.$router.push({
                name: 'administration-subscribers-edit',
                params: {id: id}
            });
        }
    },
}
</script>
